<div id="about-us">
    <div class="container-fluid">
        <div class="row">
            <div class="col-12">
                <div class="inner-card">
                    <h4 class="card-title">Principal's Message</h4>
                    <div class="card-body text-justify">
                        
                        <p class="text-justify inner-lead">Maharana pratap public school is  an inclusive institution dedicated to providing quality education to students from all backgrounds and socio-economic classes.</p>
                        <p class="inner-lead">Our mission is to foster holistic development in our students, empowering them to become well-rounded individuals who excel academically, socially, and emotionally.</p>
                        <p class="inner-lead">We strive to create a nurturing environment that promotes intellectual curiosity, creativity, and critical thinking. Our experienced faculty and staff are committed to delivering quality education that prepares students for success in all aspects of life.</p>
                        <p class="inner-lead">We believe that education goes beyond academics. We aim to shape our students into good human beings, socially responsible individuals, and ideal citizens who contribute positively to society.</p>
                        <p class="inner-lead">We invite students from all walks of life to join our vibrant community and embark on a journey of learning, growth, and self-discovery.</p>
                        <p class="inner-lead fw-bold">Regards</p>
                        <p class="inner-lead fw-bold">Pratima Sharma</p>
                        <p class="inner-lead fw-bold">Principal, Maharana Pratap Public school, Kurukshetra</p>
                       
                    </div>
                </div>

            </div>
        </div>

       
    </div>
</div>